// Names the team reads, for codes the server sends.
export const ROLE_NAME: Record<string, string> = { rep: "KAM", caller: "Call desk", manager: "Manager", admin: "Admin", ops: "Ops" };
export const LEAD_LABEL: Record<string, string> = {
  new: "New", contacted: "Contacted", interested: "Interested", meeting: "Meeting / demo", signed_up: "Signed up (auto)",
  kyc_approved: "KYC approved (auto)", fop: "First order (auto)", lost: "Lost",
};
